import { Component, ElementRef } from '@angular/core';

/**
 * Password Reveal Component
 *
 * Required Attributes:
 *    @ passwordElementId: Id of the password element
 */

@Component({ standalone: false, selector: 'ycn-password-reveal', templateUrl: './password-reveal.template.html' })
export class PasswordRevealComponent {
    // Inputs can only be bound in templates of a component (not a Django template).
    // To pass data from the Django template to this component, we use an HTML attribute.
    passwordElementId: string;

    showPassword: boolean; // pragma: allowlist secret

    constructor(private eltRef: ElementRef) {
        this.passwordElementId = eltRef.nativeElement.getAttribute('passwordElementId');

        this.showPassword = false; // pragma: allowlist secret
    }

    changePassInputType(): void {
        this.showPassword = !this.showPassword; // pragma: allowlist secret
        const passwordElement = document.getElementById(this.passwordElementId);

        if (passwordElement === null) {
            return;
        }

        if (this.showPassword) {
            (passwordElement as HTMLInputElement).type = 'text';
        } else {
            (passwordElement as HTMLInputElement).type = 'password';
        }
    }
}
